import React, { useEffect } from "react";
import ApplicationRouter from 'components/general/ApplicationRouter';
import { Provider } from 'react-redux'
import { store } from 'state-management/store'
import { ViewportProvider } from 'components/general/useViewPort'
import { getLanguages, useObtainDataArray, getConfigCompetitions } from 'data/Querys';
import { useSearchParams } from 'react-router-dom';
import Loader, { LoaderEntry } from 'components/general/Loader';
import NotAvailable from 'components/common/NotAvailable';
import { useAbsoluteRoot } from 'helpers/urlRoot';

export default function App() {
  useEffect(() => {
    let root = document.getElementById("root")
    window.addEventListener('OnContentLoad', ephemeralHandler1)
    window.addEventListener('OnLinkClicked', ephemeralHandler2)
    window.addEventListener('OnFilter', ephemeralHandler3)

    return () => {
      window.removeEventListener('OnContentLoad', ephemeralHandler1)
      window.removeEventListener('OnLinkClicked', ephemeralHandler2)
      window.removeEventListener('OnFilter', ephemeralHandler3)
    }
  }, [])

  const ephemeralHandler1 = (e) => {
    if (process.env.REACT_APP_DEVELOPMENT === 'DEV' || process.env.REACT_APP_DEVELOPMENT === 'MT') {
      console.log('OnContentLoad event triggered:', e?.detail)
    }
  }
  const ephemeralHandler2 = (e) => {
    if (process.env.REACT_APP_DEVELOPMENT === 'DEV' || process.env.REACT_APP_DEVELOPMENT === 'MT') {
      console.log('OnLinkClicked event triggered:', e?.detail)
    }
  }

  const ephemeralHandler3 = (e) => {
    if (process.env.REACT_APP_DEVELOPMENT === 'DEV' || process.env.REACT_APP_DEVELOPMENT === 'MT') {
      console.log('OnFilter event triggered:', e?.detail)
    }
  }
  return (
    <Layout>
      <Provider store={store}>
        <ViewportProvider>
          <DataAndRouter />
        </ViewportProvider>
      </Provider>
    </Layout>
  );
}

function Layout({ children }) {
  return (
    <div id='mirs-app'>
      <Theme />
      {children}
    </div>
  );
}

export function Theme() {
  const [searchParams] = useSearchParams();
  let swDark = searchParams.get('displayAsWebViewdark')?.toLowerCase() === 'true';
  if (typeof document !== 'undefined') {
    // code that relies on the document object
    if (swDark) {
      document.body.classList.remove('light-theme')
      document.body.classList.add('dark-theme')
    } else {
      document.body.classList.remove('dark-theme')
      document.body.classList.add('light-theme')
    }
  }
  return (null)
}

function DataAndRouter() {
  const { urlRoot } = useAbsoluteRoot()
  let queryArray = [];

  queryArray.push({
    queryKey: ['CC_Languages'],
    queryFn: getLanguages,
    refetchInterval: 0,
    staleTime: Infinity,
    refetchIntervalInBackground: true,
    retry: false,
    suspense: false,
  })

  queryArray.push({
    queryKey: ['ConfigCompetitions', urlRoot],
    queryFn: getConfigCompetitions,
    refetchInterval: 0,
    refetchOnWindowFocus: false
  })

  const data = useObtainDataArray({ queries: queryArray });
  const isLoading = data.some(result => result.isLoading)
  const isError = data.some(result => result.isError)

  if (isError) { return <NotAvailable />; }
  if (isLoading) { return <LoaderEntry />; }

  return (
    <ApplicationRouter />
  )

}
